/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlossaryFileSupport
 */
export interface GlossaryFileSupport {
    /**
     * 
     * @type {string}
     * @memberof GlossaryFileSupport
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryFileSupport
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlossaryFileSupport
     */
    supportedLanguages: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof GlossaryFileSupport
     */
    updatedUtc?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GlossaryFileSupport
     */
    glossaryId: string;
}

/**
 * Check if a given object implements the GlossaryFileSupport interface.
 */
export function instanceOfGlossaryFileSupport(value: object): value is GlossaryFileSupport {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('supportedLanguages' in value) || value['supportedLanguages'] === undefined) return false;
    if (!('glossaryId' in value) || value['glossaryId'] === undefined) return false;
    return true;
}

export function GlossaryFileSupportFromJSON(json: any): GlossaryFileSupport {
    return GlossaryFileSupportFromJSONTyped(json, false);
}

export function GlossaryFileSupportFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlossaryFileSupport {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'supportedLanguages': json['supportedLanguages'],
        'updatedUtc': json['updatedUtc'] == null ? undefined : (new Date(json['updatedUtc'])),
        'glossaryId': json['glossaryId'],
    };
}

export function GlossaryFileSupportToJSON(json: any): GlossaryFileSupport {
    return GlossaryFileSupportToJSONTyped(json, false);
}

export function GlossaryFileSupportToJSONTyped(value?: GlossaryFileSupport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'supportedLanguages': value['supportedLanguages'],
        'updatedUtc': value['updatedUtc'] === null ? null : ((value['updatedUtc'] as any)?.toISOString()),
        'glossaryId': value['glossaryId'],
    };
}

